import { useEffect, useState } from "react";

import ReturnButton from "../../components/Buttons/ReturnButton";
import PageTitle from "../../components/PageTitle";
import Spinner from "../../shared/Spinner/Spinner";
import api from "../../services/api";
import Style from "./UserJournalStyle";
import { customDateTimeFormat, Sort } from "../../utils";
import { FaDownload } from "react-icons/fa";

export interface JournalSession {
  sessionId: number;
  createdAt: number;
}

export function UserJournal(props) {
  const [loading, setLoading] = useState(false);
  const [downloadingSpreadSheet, setDownloadingSpreedSheet] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [journalSessions, setJournalSessions] = useState<JournalSession[]>([]);

  const userId = parseInt(props.match?.params?.userId) || 0;

  useEffect(() => {
    getUserJournalRequest();
  }, []);

  async function getUserJournalRequest() {
    try {
      setLoading(true);
      const result = await api.get(`journal/${userId}`);
      if (result.data.success) {
        setJournalSessions(Sort(result.data.journal, j => j.createdAt, true));
      } else {
        setErrorMessage(
          result.data?.message || "Não foi possível buscar dados de sessão"
        );
        console.error("Não pode pegar os dados de sessão: ", result.data);
      }
    } catch (error: any) {
      console.error("Erro pegando os dados de sessão: ", error);
      setErrorMessage(
        error.response?.data?.message ||
        "Não foi possível buscar os dados de sessão"
      );
    } finally {
      setLoading(false);
    }

  }

  async function downloadSpreadSheet() {
    setDownloadingSpreedSheet(true);
    try {
      const response = await api.get(`journal/${userId}/download`, {
        responseType: "blob"
      });

      const blob = new Blob([response.data], {
        type: response.data.type || "application/vnd.ms-excel"
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

      const fileName =
        response.headers["content-disposition"]
          ?.split("filename=")[1]
          ?.replace(/"/g, "") || "dados.xlsx";

      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Erro baixando a planilha:", err);
    } finally {
      setDownloadingSpreedSheet(false);
    }
  }
  function goToJournalSession(sessionId: number) {
    props.history.push(`/users/${userId}/journal/${sessionId}`);
  }

  return (<Style className="default-page">
    <PageTitle title="Sessões do usuário" />
    <Spinner spinning={loading} />
    {errorMessage !== "" && <h1 className="alert"> {errorMessage}</h1>}
    <div className="top-buttons-panel">
      <ReturnButton history={props.history} />
      <button onClick={downloadSpreadSheet} disabled={downloadingSpreadSheet}>Planilha <FaDownload /></button>
    </div>
    <main className="default-main">
      <div className="panel">
        {journalSessions?.length > 0 && journalSessions.map(session => <button
          onClick={() => goToJournalSession(session.sessionId)}>
          <div>Sessão: {session.sessionId}</div>
          <div>Data {customDateTimeFormat(session.createdAt)}</div>
        </button>)
        }
        {!journalSessions?.length && <div>
          Nenhuma sessão registrada
        </div>}
      </div>
    </main>
  </Style>
  );
}
